/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSecretariatMembersListAll } from '../../models/page-secretariat-members-list-all';

export interface GetAllSecretariatMembersApiV2SecretariatMembersGet$Params {
  name?: (string | null);
  censorData?: boolean;
  org: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllSecretariatMembersApiV2SecretariatMembersGet(http: HttpClient, rootUrl: string, params: GetAllSecretariatMembersApiV2SecretariatMembersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSecretariatMembersListAll>> {
  const rb = new RequestBuilder(rootUrl, getAllSecretariatMembersApiV2SecretariatMembersGet.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('censorData', params.censorData, {});
    rb.query('org', params.org, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSecretariatMembersListAll>;
    })
  );
}

getAllSecretariatMembersApiV2SecretariatMembersGet.PATH = '/api/v2/secretariat/members';
